import { useSyncExternalStore } from 'react';
import VideoPreviewModal from './VideoPreviewModal';
import {
    closeVideoPreviewWindow,
    getActiveVideoPreviewWindow,
    subscribeToVideoPreviewWindow,
} from './videoPreviewWindowStore';

const VideoPreviewWindowHost = () => {
    const video = useSyncExternalStore(
        subscribeToVideoPreviewWindow,
        getActiveVideoPreviewWindow,
        () => null,
    );

    if (!video) return null;

    return (
        <VideoPreviewModal
            open
            close={closeVideoPreviewWindow}
            title={video.title}
            videoId={video.videoId}
            autoplay={video.autoplay}
            onEnded={video.closeOnEnded ? closeVideoPreviewWindow : undefined}
        />
    );
};

export default VideoPreviewWindowHost;
